import { createContext } from 'react';

import type { ClaimContextProps } from './useClaimProvider';

export const ClaimContext = createContext({} as ClaimContextProps);
